<script lang="ts">
  import Hero from '../lib/abschnitte/Hero.svelte';
  import KernSupport from '../lib/abschnitte/KernSupport.svelte';
  import Servicegebiet from '../lib/abschnitte/Servicegebiet.svelte';
  import SafesAbschnitt from '../lib/abschnitte/SafesAbschnitt.svelte';
  import RatgeberTeaser from '../lib/abschnitte/RatgeberTeaser.svelte';
  import Preise from '../lib/abschnitte/Preise.svelte';
  import RegistrierenAbschnitt from '../lib/abschnitte/RegistrierenAbschnitt.svelte';
</script>

<Hero />
<KernSupport />
<Servicegebiet />
<SafesAbschnitt />
<RatgeberTeaser />
<Preise />
<RegistrierenAbschnitt />
